import React, { useEffect, useState } from "react";
import { SUGAM_MOBILE_APP } from "../../utils/app-image-contant";
import { getListOfBannerWebsite } from "../../hooks/services/api-services";
import { useQuery, useQueryClient } from "react-query";
import { TableLoader } from "../snippets/template-blocks";

const Crousel = () => {
  const [bannerLoading, setBannerLoading] = useState(false)

  const getBannerListData = async () => {
    setBannerLoading(true)
    const response = await getListOfBannerWebsite({
      pageIndex: 0,
      pageSize: 1000,
      columnName: "id",
      orderBy: "desc",
    });
    if (response?.data?.responseCode === 200) {
      let obj = response?.data?.responseBody?.bannerResponseLoopList;
      setBannerLoading(false)
      obj = obj?.filter(item => item.status === 1);
      return obj;
    } else {
      setBannerLoading(false)
      return [
        {
          "id": 1,
          "bannerFile": SUGAM_MOBILE_APP,
          "status": 1,
          "createdDate": "2024-05-24",
          "updatedDate": null,
          "adminId": 12,
          "roleType": "superadmin",
          "roleId": 6
        },
      ];
    }
  };

  const [rowData, setRowData] = useState([]);

  const queryClient = useQueryClient();
  const onSuccess = (data) => {
    setRowData(data);
  }
  const { data } = useQuery('bannerList', getBannerListData, {
    staleTime: 1000 * 60 * 5,
    onSuccess: onSuccess
  });

  const cachedData = queryClient.getQueryData('bannerList');

  useEffect(() => {
    setRowData(cachedData);
  }, [cachedData])

  

  const handleBannerClick = () => {
    const newUrl = 'https://innovateindia.mygov.in/pm-yoga-awards-2025/';
    window.open(newUrl, '_blank');
  }


  return (
    <>
      <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">

          {rowData?.length > 0
            ? rowData.map((item, index) => (
              <div className={index === 0 ? "carousel-item active" : 'carousel-item'}>
                <img src={item?.bannerFile}
                  className="d-block w-100"
                  alt={'Slide' + index}
                  onClick={item?.id == 191 ? handleBannerClick : undefined}
                  style={{ cursor: item?.id === 191 ? 'pointer' : 'default' }}
                />
              </div>
            ))
            :
            <div className="homeBannerWidth"><TableLoader /></div>
          }
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </>
  );
};

export default Crousel;
